import { useElementSize } from '@custom-react-hooks/use-element-size';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import AudioPlayer from 'react-h5-audio-player';
import ErrorMessage from '../errorMessage';

type Props = {
  audioDataUrl: string;
  maxHeight: number;
  showLabel?: boolean;
  label?: string;
  error?: string;
};

const AudioPlayerComp = ({ audioDataUrl, showLabel = true, label, maxHeight, error }: Props) => {
  const [headerRef, headerSize] = useElementSize();

  return (
    <Card variant="outlined" sx={{ border: label || error ? 1 : 0, borderColor: 'divider' }}>
      {showLabel && (label || error) && (
        <CardHeader
          title={<Typography sx={{ textOverflow: 'ellipsis' }}>{label}</Typography>}
          subheader={error && <ErrorMessage error={error} />}
          sx={{ p: 1 }}
          ref={headerRef}
          disableTypography
        />
      )}
      {showLabel && (label || error) && <Divider />}
      <CardContent sx={{ overflowY: 'auto', height: `${maxHeight - headerSize.height + 5}px`, p: 0 }}>
        <AudioPlayer autoPlay src={audioDataUrl} />
      </CardContent>
    </Card>
  );
};

export default AudioPlayerComp;
